import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

// Map paths to page names for analytics
const pageNames: Record<string, string> = {
  '/': 'home',
  '/product': 'product',
  '/portfolio': 'portfolio',
  '/portfolio/radone': 'radone_reporting',
  '/portfolio/billing': 'billing_system',
  '/teleradiology': 'teleradiology',
  '/about': 'about_us',
  '/careers': 'careers',
  '/blog': 'blog',
};

// Scrolls to top and tracks analytics on route change
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view for SPA navigation
    const pageName = pageNames[location.pathname] || 'unknown';
    trackPageView(pageName);

    // Handle hash scrolling
    if (location.hash) {
      // Remove the # character
      const elementId = location.hash.substring(1);
      const element = document.getElementById(elementId);
      
      if (element) {
        // Small delay to ensure the page has rendered
        setTimeout(() => {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      }
    } else {
      // Scroll to top on route change if no hash
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

export default ScrollToTop;